import React, { FC, useEffect } from "react";

import {
  useThemeColors,
  KSectionTitleWidgetChipStyle,
  KSectionTitleWidget as KSectionTitleWidgetComponent,
} from "@keepeek/refront-components";

import { Chip } from "../../../models/configuration/components/kNewsWidget";
import { TranslationSchema } from "../../../models/configuration/labels";
import { useCurrentLocale } from "../../../providers/i18n/hooks";
import { WidgetUIState } from "../atoms";
import { useWidgetState } from "../hooks";
import KNewsWidgetContent from "../KNewsWidget/KNewsWidgetContent";
import { KWidgetProps } from "../models";

export type KSectionTitleWidgetProps = {
  widgetId: string;
  backgroundColor?: string;
  borderRadius?: string;
  chip?: Chip;
  content?: TranslationSchema[];
} & KWidgetProps;

const KSectionTitleWidget: FC<React.PropsWithChildren<KSectionTitleWidgetProps>> = function ({
  backgroundColor,
  borderRadius,
  chip,
  content,
  widgetId,
  type,
}) {
  const currentLocale = useCurrentLocale();
  const { setWidgetState, widgetState } = useWidgetState({
    id: widgetId,
    type,
  });
  const { convertColor } = useThemeColors();

  const translatedChip = {
    ...chip,
    color: convertColor(chip?.color),
    labelColor: convertColor(chip?.labelColor),
    label: chip?.label?.find((u) => u.language === currentLocale)?.value || "",
    style: chip?.style ? (chip.style as unknown as KSectionTitleWidgetChipStyle) : undefined,
  };

  const translatedContent = content?.find((c) => c.language === currentLocale)?.value;

  useEffect(() => {
    // Do not render if we do not have at least:
    if (!(translatedContent || !!translatedChip.label)) {
      setWidgetState({ state: WidgetUIState.NULL });
    } else {
      setWidgetState({ state: WidgetUIState.RENDERED });
    }
  }, [setWidgetState, translatedContent, translatedChip.label]);

  if (widgetState.state === WidgetUIState.RENDERED) {
    return (
      <KSectionTitleWidgetComponent
        backgroundColor={convertColor(backgroundColor)}
        borderRadius={borderRadius}
        id={widgetId}
        content={<KNewsWidgetContent content={translatedContent} />}
        chip={translatedChip}
      />
    );
  }
  return null;
};

export default KSectionTitleWidget;
